import React, { FC } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "",
    },
  },
};

const labels = ["Status"];

// export const data = {
//   labels,
//   datasets: [
//     {
//       label: "Created",
//       data: [20],
//       backgroundColor: "rgba(255, 99, 132, 0.5)",
//     },
//     {
//       label: "Assigned",
//       data: [10],
//       backgroundColor: "rgba(53, 162, 235, 0.5)",
//     },
//   ],
// };

const VerticalGraph: FC<{data}> = ({data}) => {
  return (
    <Bar
      options={{
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            text: "",
          },
        },
      }}
      data={data}
    />
  );
};

export default VerticalGraph;
